import { isImageUrl } from "../detect";
import { PRIORITY, type ValueRenderer } from "../types";

const IMAGE_KEY_RE = /(image|thumb|icon|avatar|logo|photo)/i;

export const ImageRenderer: ValueRenderer = {
  id: "image",
  match: (value, ctx) => {
    if (typeof value !== "string" || !/^https?:\/\//.test(value)) return null;
    if (isImageUrl(value)) return { priority: PRIORITY.CONTENT_SNIFFED, confidence: "high" };
    if (ctx.key && IMAGE_KEY_RE.test(ctx.key)) return { priority: PRIORITY.CONTENT_SNIFFED, confidence: "low" };
    return null;
  },
  Component: ({ value }) => (
    <a href={value as string} target="_blank" rel="noopener noreferrer" className="inline-block">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={value as string}
        alt=""
        className="border-ds-border-default max-h-24 max-w-[160px] rounded-md border object-contain"
        loading="lazy"
      />
    </a>
  ),
};
